<template>
  <div class="choose-area pct100 flex-layout">
    <el-input :disabled="disabled"
              class="margin10"
              :placeholder="placeholder"
              readonly
              v-model="formatArea">
      <el-button :disabled="disabled"
                 slot="suffix"
                 type="text"
                 @click="queryArea">选择</el-button>
    </el-input>
    <app-area-tree ref="areaTree"
                   :showCheckbox="false"
                   @saveChecked="change"></app-area-tree>
    <!-- <el-dialog title="选择区域" :visible.sync="showArea" :before-close="close" @close="close">
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="submit()">{{ $t('workOrder.button.confirm') }}</el-button>
        <el-button @click="close">{{ $t('workOrder.button.cancel') }}</el-button>
      </div>
    </el-dialog>-->
  </div>
</template>

<script>
import { api } from '../api'
// import appAreaTree from '@src/components/business/app-alarm/RegionTree.vue'
import appAreaTree from '@src/components/business/app-area-tree'
export default {
  name: 'choose-area',
  model: {
    prop: 'selectArea',
    event: 'handleReturn'
  },
  components: {
    appAreaTree
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    selectArea: {
      type: String,
      default: ''
    }
  },
  watch: {
    selectArea (newVal) {
      this.areas = newVal.split(':');
    },
    areas (newVal) {
      this.areas = newVal;
      this.$emit('handleReturn', this.areas.join(':'));
    }
  },
  computed: {
    formatArea () {
      // 单选
      return this.areas[0]
    }
  },
  data () {
    return {
      areas: [],
      showArea: false,
    }
  },
  mounted () {
    this.areas = this.selectArea.split(':');
    console.log(this.areas)
    //     let list = []
    //     this.areas.map(el => {
    //      list.push(el.split(":"))
    // })
    this.$emit('handleReturn', this.areas.join(':'));
  },
  methods: {
    queryArea () {
      // this.showArea = true;
      console.log(this.areas)
      // this.$refs['areaTree'].open(this.areas)
      // console.log(this.areas.split("|"))
      this.$refs['areaTree'].openDialog(this.areas)
    },
    submit () {
      this.selectPerson = this.$refs.tree.getCheckedNodes();
      // this.showArea = false;
    },
    close () {
      // this.showArea = false;
    },
    change (val) {
      // 单选逻辑
      // this.areas = [val[0].areaDevGroupCode, val[0].areaDevGroupName];
      this.areas = [val[0].areaDevGroupName, val[0].areaDevGroupCode];
      // 多选逻辑
      // let list = []//全部数据
      // let name = []
      // val.map((el, index) => {
      //   name.push(el.areaDevGroupName)
      //   list[index] = [el.areaDevGroupCode, el.areaDevGroupName].join(":")
      // })
      // this.areas = list
      // this.formatArea = name.join(',')
    }
  }
}
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";
.choose-person {
  z-index: 99;
  position: relative;
  .person-show {
    background-color: #262a49;
    // @include set_theme_color(background-color, dialog-main-bg-color);
    .header {
      background-color: #272b37;
    }
    .body {
      background-color: #171c28;
    }
    .footer {
      padding: 5px;
      background-color: #272b37;
    }
    .person-list {
      overflow: hidden;
      height: 200px;
    }
  }
}
</style>